<section id="partner_list_link" class="legal-section">
  <h3 class="legal-header">{{'partner_list_title'| translate}}</h3>
  <div class="legal-table-container">
    <table class="legal-table">
      <thead>
        <tr class="legal-table-tr">
          <th *ngFor="let title of columnsTitles" class="legal-table-th">{{ title.text }}</th>
        </tr>
      </thead>
      <tbody *ngFor="let info of tableInfo" class="legal-table-body">
        <tr>
          <th class="legal-table-th" [attr.colspan]="8">{{ info.title }}</th>
        </tr>
        <tr *ngFor="let row of info.rows" class="legal-table-tr">
          <td *ngFor="let info of row.rowInfo" class="legal-table-td">{{ info.text }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
